import { render, staticRenderFns } from "./AdBalanceTopUpTrigger.vue?vue&type=template&id=56522f8e&scoped=true&"
import script from "./AdBalanceTopUpTrigger.vue?vue&type=script&lang=ts&"
export * from "./AdBalanceTopUpTrigger.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56522f8e",
  null
  
)

export default component.exports